// @ts-nocheck
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

/**
 * RedirectToNewRegistration Component
 * 
 * Redirects old registration URLs to the new modular registration system.
 * Handles both slug-based and ID-based event identification.
 */
const RedirectToNewRegistration = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      if (!slug) {
        navigate('/events');
        return;
      }
      
      // Look up event by slug or ID
      const { data: event } = await supabase
        .from('events')
        .select('id, slug')
        .or(`slug.eq.${slug},id.eq.${slug}`)
        .single();
      
      if (event) {
        navigate(`/events/${event.slug ?? slug}/register`, { replace: true });
      } else {
        navigate('/events', { replace: true });
      }
    };
    
    redirect();
  }, [slug, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground">Redirecting to registration...</p>
    </div>
  );
};

export default RedirectToNewRegistration;